import { render, staticRenderFns } from "./CommonMenuAside.vue?vue&type=template&id=6fdd06a0&scoped=true"
import script from "./CommonMenuAside.vue?vue&type=script&lang=js"
export * from "./CommonMenuAside.vue?vue&type=script&lang=js"
import style0 from "./CommonMenuAside.vue?vue&type=style&index=0&id=6fdd06a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdd06a0",
  null
  
)

export default component.exports